import { Component, OnInit } from '@angular/core';
import { AppLayoutComponent } from './app-layout/app-layout.component';
import { RouterModule, RouterOutlet } from '@angular/router';
import { CommonModule, KeyValuePipe } from '@angular/common';
import { ActiveAuthenticationStateService } from "@auth/active-authentication.state-service";
import { BannerComponent } from '@design-system/layout/banners/banner-layout/banner.component';
import { BannerService } from '@design-system/layout/banners/banner-layout/banner.service';
import { CookieConsentBannerComponent } from '@design-system/layout/banners/cookie-consent/cookie-consent-banner.component';
import { UnityCookieService } from '@utils/unity-cookie.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, take } from 'rxjs/operators';
import { TestIdDirective } from '@design-system/core/test-id.directive';

@UntilDestroy()
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    AppLayoutComponent,
    RouterOutlet,
    RouterModule,
    CommonModule,
    BannerComponent,
    KeyValuePipe,
    TestIdDirective
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  readonly cookieConsentBannerName = 'cookie-consent';
  readonly CookieConsentBannerComponent = CookieConsentBannerComponent;
  readonly bannerService = this._bannerService;
  activeIdentity$ = this.activeAuthentication.activeIdentity$;

  constructor(
    private activeAuthentication: ActiveAuthenticationStateService,
    private _bannerService: BannerService,
    private cookieService: UnityCookieService
  ) {}

  ngOnInit(): void {
    const hasConsent = this.cookieService.getCookie('unity-system-cookieConsent') === 'accepted';
    
    if (!hasConsent) {
      this._bannerService.show(this.cookieConsentBannerName, CookieConsentBannerComponent);

      this._bannerService.banners$
        .pipe(
          filter(banners => !banners.has(this.cookieConsentBannerName)),
          take(1),
          untilDestroyed(this)
        )
        .subscribe(() => {
          this.cookieService.setConsentState(true);
        });
    }
  }
}
